"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeBodyClose = exports.addBodyClose = void 0;
var _w3cKeys = require("w3c-keys");
var _DomUtils = require("./DomUtils");
var bodyClickMap = new Map();
var bodyKeyDownMap = new Map();
var addBodyClose = function addBodyClose(widgetElement, callback) {
  var handleBodyClick = function handleBodyClick(e) {
    if (!widgetElement || (0, _DomUtils.isTargetInsideContainer)(e.target, widgetElement)) {
      return;
    }
    e.preventDefault();
    callback(e);
  };
  var onKeyDown = function onKeyDown(e) {
    switch (e.key) {
      case _w3cKeys.Key.Escape:
        e.preventDefault();
        callback(e);
        return;
      default:
        break;
    }
  };
  bodyClickMap.set(callback, handleBodyClick);
  bodyKeyDownMap.set(callback, onKeyDown);
  // TODO: check if { capture: true } is required to prevent bugs with react >= 17
  document.body.addEventListener("click", handleBodyClick);
  document.body.addEventListener("keydown", onKeyDown);
};
exports.addBodyClose = addBodyClose;
var removeBodyClose = function removeBodyClose(callback) {
  var handleBodyClick = bodyClickMap.get(callback);
  var onKeyDown = bodyKeyDownMap.get(callback);
  // TODO: check if { capture: true } is required to prevent bugs with react >= 17
  document.body.removeEventListener("click", handleBodyClick);
  document.body.removeEventListener("keydown", onKeyDown);
  bodyClickMap["delete"](callback);
  bodyKeyDownMap["delete"](callback);
};
exports.removeBodyClose = removeBodyClose;